module.exports = __webpack_public_path__ + "static/MontserratAlternates-Bold-d25c99d7239722318d87d5501289be8e.ttf";